import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserIdentityResource } from './user-identity.resource';
import { UserIdentityService } from './user-identity.service';

@Injectable({ providedIn: 'root' })
export class UserIdentityResolver implements Resolve<UserIdentityResource> {
    constructor(private service: UserIdentityService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserIdentityResource> {
        const userUuid = route.paramMap.get('userUuid');
        if (!userUuid) {
            throw new Error(`parameter "userUuid" expected in route ${route.toString()}`);
        }
        if (userUuid === 'new') {
            // Not to break "new" values in urls
            return of({ username: userUuid, uuid: undefined, _links: undefined });
        }
        return this.service.fetchIdentity(userUuid);
    }
}

export interface UserIdentityResolveData {
    userIdentity: UserIdentityResource;
}
